import { DataGrid } from "@mui/x-data-grid";
import { styled } from "styled-components";

export const CardLabel = styled.div`
  text-transform: uppercase;
  color: #8c98a4;
  font-size: 0.8rem;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.5em;
`;

export const StyledDataGrid = styled(DataGrid)`
.row-with-deviation {
background-color: #ffcccb;
}
`;
